import { Outlet, NavLink, useNavigate } from "react-router-dom";

export default function AdminLayout() {
  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem("adminSession");
    navigate("/admin/login");
  };

  return (
    <div className="flex min-h-screen bg-gray-100">

      {/* Sidebar */}
      <div className="w-64 bg-white shadow-md p-4 flex flex-col">
        <h2 className="text-xl font-bold mb-6">Admin Panel</h2>

        <nav className="space-y-2 flex-1">
          <NavLink className="block p-2 rounded hover:bg-gray-200" to="/admin/compliance">
            Compliance
          </NavLink>

          <NavLink className="block p-2 rounded hover:bg-gray-200" to="/admin/blogs">
            Blogs
          </NavLink>

          <NavLink className="block p-2 rounded hover:bg-gray-200" to="/admin/testimonials">
            Testimonials
          </NavLink>
        </nav>

        <button
          onClick={logout}
          className="mt-4 bg-red-600 text-white py-2 rounded"
        >
          Logout
        </button>
      </div>

      {/* Main Body */}
      <div className="flex-1 p-6">
        <Outlet />
      </div>
    </div>
  );
}
